import * as ng from 'angular';
import { NgPrint } from './ng-print.directive';

export const NgPrintModule: string =
    ng.module('ng-print', [
    ])
        .directive('ngPrint', NgPrint)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/ng-print/ng-print.module.ts